import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699d7243f782d5001451ee32/kenyatourismportal/src/app/admin-dashboard/components/AdminDashboardClient.tsx");
